import { TicketFareStateEnum, TicketFareStateService } from '@/api';

export default {
  getTicketFareStateList: async (): Promise<TicketFareStateEnum[]> => {
    const response = await TicketFareStateService.ticketFareStateControllerGetAll();
    return response.data;
  },
};
